import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";



const AddCountry = ({ show, onClose }) => {

    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#dcf1dc' }}>
                    <h3 className="modal-title">Create Country</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Country<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Country Name" />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Create Country</Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddCountry;
